import React from 'react';
import styled from 'styled-components';
import Big from 'big.js';
import clamp from 'lodash/clamp';

interface ProgressBarProps {
  size: number;
  progress: number; // A value between 0 and 100
  progressColor: string;
  backgroundColor: string;
  strokeWidth: number;
}

const Svg = styled.svg`
  display: block;
  margin: auto;
`;

const Circle = styled.circle`
  transform-origin: center;
  transition: stroke-dashoffset 0.3s ease-in-out;
`;

const ProgressBarCircle: React.FC<ProgressBarProps> = ({
  size,
  progress,
  progressColor,
  backgroundColor,
  strokeWidth,
}) => {
  const radius = (size - strokeWidth) / 2; // Radius of the inner circle
  const circumference = radius * 2 * Math.PI; // Circumference of the inner circle

  // Normalize the progress value to be between 0 and 100
  const normalizedProgress = clamp(progress, 0, 100);
  const normalizedBigProgress = Big(normalizedProgress);
  const progressPercentage = normalizedBigProgress.div(100).toNumber();

  // The stroke dash array and offset create the effect of the progress bar
  const strokeDasharray = circumference.toFixed(2);
  const strokeDashoffset = (circumference - progressPercentage * circumference).toFixed(2);
  return (
    <Svg height={size} width={size} viewBox={`0 0 ${size} ${size}`}>
      <Circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={backgroundColor} strokeWidth={strokeWidth} />
      <Circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={progressColor}
        strokeWidth={strokeWidth}
        style={{
          strokeDasharray,
          strokeDashoffset,
          strokeLinecap: 'round',
          transform: `rotate(-90deg)`,
        }}
      />
    </Svg>
  );
};

export default ProgressBarCircle;
